/**
 * 劫持随手记返回按钮
 * 目前适用于随手记，不支持卡牛
 */

import { call, uriSuishouji } from './bridge'

const requestBackActionNotify = (callback) => {
  call(uriSuishouji('requestBackActionNotify', {}, 'requestBackActionNotifyCb'), 'requestBackActionNotifyCb', (jsonResult) => {
    try {
      callback(JSON.parse(jsonResult))
    } catch (e) {
      // 对错误不处理
    }
  })
}

export default requestBackActionNotify